<template>
   <div
        v-if="show"
        class="notification"
        :class="[type]"
    >
        <div>
            {{ text }}
        </div>
        <button
            @click.prevent="reset"
            class="rouned-full p-2 flex items-center justify-center"
        >
            <icon type="x" class="w-4 h-4" />
        </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Icon from './shared/Icon';

export default {
    computed: {
        text() {
            return this.$store.state.notification.text
        },
        type() {
            return this.$store.state.notification.type
        },
        show() {
            return !!(this.type && this.text)
        }
    },
    methods: mapActions({
        reset: 'clearNotification'
    }),
    created() {
        this._escapeListener = window.addEventListener('keyup', (e) => {
            if(['Esc', 'Escape'].includes(e.key)) {
                this.reset();
            }
        })
    },
    components: {
        Icon
    }
}
</script>
